export type CveSeverity = 'Critical' | 'High' | 'Medium' | 'Low';

export const cveTheme = {
  panelBackground: '#141414',
  panelBorder: '#2A2A2A',
  divider: '#3A1115',
  link: '#FFFFFF',
  label: '#FFFFFF',
  labelMuted: '#FFFFFF',
  textPrimary: '#FFFFFF',
  textSecondary: '#FFFFFF',
  kevListed: '#FFFFFF',
  kevDot: '#FFFFFF',
  kevNotListed: '#FFFFFF',
  epss: '#FFFFFF',
} as const;

export const getCveCvssColor = (score: number): string => {
  if (score >= 9.0) return '#7F1D1D'; // bg-red-900 tone
  if (score >= 7.0) return '#EF4444'; // bg-red-500 tone
  if (score >= 4.0) return '#CA8A04'; // bg-yellow-600 tone
  return '#16A34A'; // bg-green-600 tone
};

export const getCveSeverityStyle = (severity?: string): { bg: string; text: string; border: string } => {
  const styles: Record<CveSeverity, { bg: string; text: string; border: string }> = {
    Critical: { bg: '#450a0a', text: '#fecaca', border: '#7f1d1d' }, // red-900 family
    High: { bg: '#450a0a', text: '#fca5a5', border: '#ef4444' }, // red-500 family
    Medium: { bg: '#422006', text: '#fde68a', border: '#ca8a04' }, // yellow-600 family
    Low: { bg: '#052e16', text: '#bbf7d0', border: '#16a34a' }, // green-600 family
  };

  if (severity && severity in styles) {
    return styles[severity as CveSeverity];
  }

  return { bg: '#1a1a1a', text: '#d1d5db', border: '#374151' };
};
